import { getBooleanClassifiersOLD } from "./classifierManager";
import { getCurrentYear } from "./validationHelper";

export function strToNum(valIn: string | undefined): number | undefined {
  if (valIn) {
    const rVal = parseInt(valIn);
    if (!isNaN(rVal)) {
      return rVal;
    }
  }
  return undefined;
}

export const toISODate = (timestamp: string | undefined): DateString => {
  if (!timestamp) {
    return "";
  }
  return new Date(timestamp).toISOString().slice(0, 10);
};

export const toLocaleDate = (timestamp: string | undefined, locale = "et"): DateString => {
  if (!timestamp) {
    return "";
  }
  return new Date(timestamp).toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const convertPeriodToLocaleDate = (period: string | undefined, locale = "et"): string => {
  if (!period) {
    return "";
  }
  const [start, end] = period.split("-");
  const startDateString = toLocaleDate(start.trim(), locale);
  const endDateString = toLocaleDate(end.trim(), locale);

  return `${startDateString} - ${endDateString}`;
};

export const toLocale = (timestamp: string | undefined, locale = "et"): DateString => {
  if (!timestamp) {
    return "";
  }
  return new Date(timestamp).toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    //omitting seconds
  });
};

export const toLocaleHMin = (timestamp: string | number | undefined, locale = "et"): DateString => {
  if (!timestamp) {
    return "";
  }
  return new Date(timestamp).toLocaleString(locale, {
    hour: "numeric",
    minute: "numeric",
    //omitting seconds
  });
};

export const toFutureLocaleDate = (amountOfDays: number | undefined, locale = "et"): DateString => {
  if (!amountOfDays) {
    return "";
  }
  const currentDate = new Date(Date.now());
  currentDate.setDate(currentDate.getDate() + amountOfDays);
  return currentDate.toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const addDaysToDate = (amountOfDays: number | undefined, dateTime: number | string | undefined): string => {
  if (!amountOfDays || !dateTime) {
    return "";
  }
  const currentDate = new Date(dateTime);
  currentDate.setDate(currentDate.getDate() + amountOfDays);
  return currentDate.toISOString();
};

export type DateString = string;

/*
 * Deprecated
 */
export const booleanToLabel = (myBoolean: boolean | undefined, t: any): string => {
  if (myBoolean === true) return t("common.yes");
  if (myBoolean === false) return t("common.no");
  return "";
};

/*
 * Deprecated? - not yet - used to translate classifier value boolean text to boolean type
 */
export function parseBoolean(valIn: string | undefined): boolean | undefined {
  if (valIn === "true") return true;
  if (valIn === "false") return false;
  return undefined;
}

export function getBooleanClassifier(booleanValue: boolean, t: any) {
  const classifiers = getBooleanClassifiersOLD(t);
  if (booleanValue === true) {
    return classifiers[0];
  } else {
    return classifiers[1];
  }
}

export function toNameAddress(name: string | undefined, address: string | undefined) {
  if (name && address) {
    return `${name}, ${address}`;
  } else if (name) {
    return `${name}`;
  } else if (address) {
    return `${address}`;
  } else {
    return "";
  }
}

export interface FormattedDecimal {
  value: number;
  formattedValue: string;
  spacedValue?: string;
}

export function toMoney(money: number | undefined, locale = "et"): FormattedDecimal | undefined {
  return money || money === 0
    ? {
        formattedValue: money.toLocaleString(locale, {
          maximumFractionDigits: 2,
          useGrouping: false,
        }),
        spacedValue: money.toLocaleString(locale, {
          maximumFractionDigits: 2,
          useGrouping: true,
        }),
        value: money,
      }
    : undefined;
}

export function toFormattedDecimal(decimal: number | undefined, locale = "et"): FormattedDecimal | undefined {
  return decimal || decimal === 0
    ? {
        formattedValue: decimal.toLocaleString(locale, {
          useGrouping: false,
        }),
        spacedValue: decimal.toLocaleString(locale, {
          useGrouping: true,
        }),
        value: decimal,
      }
    : undefined;
}

export const UNSPECIFIED = null;

export enum Unspecified {
  UNSPECIFIED = "UNSPECIFIED",
}

export function formatAsYear(date: string | undefined) {
  if (date) {
    return new Date(date).getFullYear() + "";
  }
  return undefined;
}

export function formatAsYearStrict(date: string) {
  return new Date(date).getFullYear() + "";
}

export function getMinYear(year: string) {
  const curYear = getCurrentYear();
  const yearIn = strToNum(year);
  if (yearIn == undefined || yearIn <= curYear) {
    return curYear;
  } else {
    return yearIn;
  }
}
